import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { AppConfigurationUrlQueryParams } from "./url";
import AppConfigurationDetailComponent from "./views/AppConfigurationDetail";
import AppConfigurationComponent from "./views/AppConfigurationListPage";

const AppConfiguration: React.FC = () => {
  const qs = parseQs(location.search.substr(1));
  const params: AppConfigurationUrlQueryParams = qs;

  return <AppConfigurationComponent params={params} />;
};

const AppConfigurationDetail: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: AppConfigurationUrlQueryParams = qs;

  return (
    <AppConfigurationDetailComponent
      params={params}
      id={decodeURIComponent(id)}
    />
  );
};

export const AppConfigurationSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.appConfiguration)} />
      <Routes>
        <Route path={""} element={<AppConfiguration />} />
        <Route path={":id"} element={<AppConfigurationDetail />} />
      </Routes>
    </>
  );
};
export default AppConfigurationSection;
